module.exports = __webpack_public_path__ + "static/media/red.1f925be0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header/layers/red.png
// module id = 279
// module chunks = 0